<template lang="html">
  <div class="pt-5">
    <div v-show="submitting" class="loading-wrapper layout align-center justify-center">
      <img src="/img/loading_wh.gif" alt="[Gif]" height="100" />
    </div>

    <div class="mt-5 pt-2 hor-bg-padding">
      <input v-model="password" type="password" class="form-input" placeholder="password" />
      <input
        v-model="password_confirmation"
        type="password"
        class="form-input mt-3"
        placeholder="password(confirmation)"
      />
      <div class="font-red text-left mt-1" v-html="password_err"></div>
      <div class="text-center">
        <v-btn color="#b21977" class="send-btn mt-4" depressed @click="submit()">
          <span class="font-white font-bold fa-1_1x sp-xs-space">Send</span>
        </v-btn>
      </div>
    </div>

    <v-dialog v-model="dialog" persistent max-width="500px">
      <v-card class="pa-3">
        <div class="font-purple">
          <div class="fa-1_2x font-bold">Changed password successfully.</div>
          <div class="mt-2">
            Already have the App?<br />
            <a :href="appUrlScheme">Open fondi→</a>
          </div>
          <div class="mt-2">
            Haven't downloaded fondi yet?<br />
            <a :href="app_link" target="_blank">find fondi on {{ store }}</a>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { AppUrlScheme } from '../../../utils/app_utils';

export default {
  data() {
    return {
      password: '',
      password_confirmation: '',
      password_err: '',
      submitting: false,
      dialog: false,
      app_link: '',
      store: '',
      appUrlScheme: AppUrlScheme,
    };
  },

  mounted() {
    var userAgent = window.navigator.userAgent;
    var device;
    if (userAgent.indexOf('msie') != -1 || userAgent.indexOf('trident') != -1) {
      device = 'Internet Explorer';
    } else if (userAgent.indexOf('edge') != -1) {
      device = 'Edge';
    } else if (userAgent.indexOf('iPhone') != -1) {
      device = 'iPhone';
    } else if (userAgent.indexOf('Android') != -1) {
      device = 'Android';
    } else {
      device = 'undefined';
    }
    if (device == 'iPhone') {
      this.app_link = 'https://apps.apple.com/us/app/fondi/id1479328028?mt=8'; // iOS App Store
      this.store = 'iOS App Store';
    } else if (device == 'Android') {
      this.app_link =
        'https://play.google.com/store/apps/details?id=com.Fondi.Fondi&pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'; // Google Play Store
      this.store = 'Google Play Store';
    }
  },

  methods: {
    submit() {
      this.password_err = '';
      this.submitting = true;
      axios
        .post('/password-reset', {
          password: this.password,
          password_confirmation: this.password_confirmation,
          token: this.$route.query.token,
        })
        .then(() => {
          this.submitting = false;
          this.dialog = true;
        })
        .catch((e) => {
          this.submitting = false;
          if (e.response && e.response.status == 422) {
            this.password_err = e.response.data.password
              ? e.response.data.password[0]
              : e.response.data.password_confirmation[0];
          } else if (
            e.response &&
            e.response.status == 403 &&
            (e.response.data == 'No token.' || e.response.data == 'Already reset.')
          ) {
            this.dialog = true;
          } else {
            console.log(e.response);
            alert(
              'Something wrong has happened. Please check your email again and click password-reset link on it again.'
            );
          }
        });
    },
  },
};
</script>

<style lang="css" scoped>
.loading-wrapper {
  background: rgba(47, 3, 56, 0.5);
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 2;
}
.form-input {
  width: 100%;
  border: solid 1px #e6e0e7;
  border-radius: 5px;
  height: 35px;
  padding: 0 16px;
  font-size: 16px;
  color: #2f0338;
  font-weight: bold;
  outline: none;
}
.form-input::placeholder {
  color: #e6e0e7;
}
.send-btn {
  border-radius: 5px;
  height: 45px;
  width: 250px;
  text-transform: none;
}
</style>
